module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-00.891833a2.png";